import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { AnimationStates } from "../types/tooltips.types";

@Component({
  selector: "ds-tooltip",
  templateUrl: "./ds-tooltip.component.html",
  styleUrls: ["./ds-tooltip.component.scss"],
  standalone: true,
  imports: [CommonModule],
  animations: [
    trigger("fadeInOut", [
      state(
        "hidden",
        style({
          opacity: 0,
          transform: "scale(0.8) translateY(-8px)",
        })
      ),
      state(
        "visible",
        style({
          opacity: 1,
          transform: "scale(1) translateY(0)",
        })
      ),
      transition("hidden => visible", [animate("300ms cubic-bezier(0.25, 0.8, 0.25, 1)")]),
      transition("visible => hidden", [animate("300ms cubic-bezier(0.4, 0, 0.2, 1)")]),
    ]),
  ],
})
export class DsTooltipComponent {
  @Input() message: string = "";
  animationState: AnimationStates = "hidden";

  constructor() {}
}
